module.exports = __webpack_public_path__ + "static/media/ca_7.4cd4b7b0.png";